import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "settings-horiz",
  "use": "settings-horiz-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"settings-horiz\"><path d=\"M13.87 7H30V5H13.87a4 4 0 00-7.74 0H2v2h4.13a4 4 0 007.74 0zm-5.6 0A2 2 0 1110 8a2 2 0 01-1.73-1zM25.87 17H30v-2h-4.13a4 4 0 00-7.74 0H2v2h16.13a4 4 0 007.74 0zm-5.6 0A2 2 0 1122 18a2 2 0 01-1.73-1zM17.87 27H30v-2H17.87a4 4 0 00-7.74 0H2v2h8.13a4 4 0 007.74 0zm-5.6 0A2 2 0 1114 28a2 2 0 01-1.73-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/settings-horiz.svg
// module id = 8vIP
// module chunks = 39 44